import { getEnvironmentMode } from 'utils/env'
import { IGNORED_MESSAGES } from './constants'

import type Rollbar from 'rollbar'
import type { EnvironmentMode } from 'types/env'

const mode: EnvironmentMode = getEnvironmentMode()

export const rollbarConfig: Rollbar.Configuration = {
  accessToken: import.meta.env.VITE_ROLLBAR_POST_CLIENT_ITEM,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: mode === 'staging' || mode === 'production',
  ignoredMessages: IGNORED_MESSAGES,
  payload: {
    client: {
      guess_uncaught_frames: true,
      source_map_enabled: true,
    },
    environment: mode,
  },
  replay: {
    enabled: true,
  },
}
